import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;


const {
  estadosList,
  municipioList,
  empleadoEsquemasContractualesList,
  tipoEmpleadosList,
  sucursalEsquemasContractualesList,
  sucursalEsquemasCostosList,
  serviciosList,
} = actions;

const estadosListAction = () => {
  return async dispatch => {
    try {
      const response = await DataService.get('/catalogos/estados.php');
      if (response.status === 200 && response.data.data) {
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre }
        });
        dispatch(estadosList(registrosList));

      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const municipioListAction = (idEstado) => {
  return async dispatch => {
    try {
      const response = await DataService.get('/catalogos/municipios.php?idEstado=' + idEstado);
      if (response.status === 200 && response.data.data) {
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre }
        });
        dispatch(municipioList(registrosList));

      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const empleadoEsquemasContractualesListAction = (idEstado) => {
  return async dispatch => {
    try {
      const response = await DataService.get('/catalogos/empleadoEsquemaLaboral.php');
      if (response.status === 200 && response.data.data) {
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre }
        });
        dispatch(empleadoEsquemasContractualesList(registrosList));

      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const tipoEmpleadosListAction = (idEstado) => {
  return async dispatch => {
    try {
      const response = await DataService.get('/catalogos/tipoEmpleado.php');
      if (response.status === 200 && response.data.data) {
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre }
        });
        dispatch(tipoEmpleadosList(registrosList));

      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const sucursalEsquemasContractualesListAction = (idEstado) => {
  return async dispatch => {
    try {
      const response = await DataService.get('/catalogos/sucursalEsquemaContractual.php');
      if (response.status === 200 && response.data.data) {
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre }
        });
        dispatch(sucursalEsquemasContractualesList(registrosList));

      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const sucursalEsquemasCostosListAction = (idEstado) => {
  return async dispatch => {
    try {
      const response = await DataService.get('/catalogos/sucursalEsquemaCostos.php');
      if (response.status === 200 && response.data.data) {
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre }
        });
        dispatch(sucursalEsquemasCostosList(registrosList));

      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};


export {
  estadosListAction, municipioListAction, empleadoEsquemasContractualesListAction, tipoEmpleadosListAction,
  sucursalEsquemasContractualesListAction,
  sucursalEsquemasCostosListAction,  
};
